module.exports = __webpack_public_path__ + "media/form-type-page/random-7b24bbea.svg";